import React from 'react';
import { motion } from 'framer-motion';

interface AnimatedTextProps {
  text: string;
  className?: string;
  delay?: number;
  staggerDelay?: number;
}

/**
 * Reusable animated text component with character-by-character animation
 * Features smooth left-to-right reveal without blur for better performance
 */
const AnimatedText: React.FC<AnimatedTextProps> = ({
  text,
  className = '',
  delay = 0,
  staggerDelay = 0.02
}) => {
  const splitText = text.split('').map((char, index) => (
    <motion.span
      key={`${text}-${index}`}
      className="inline-block"
      initial={{
        opacity: 0,
        x: -10
      }}
      animate={{
        opacity: 1,
        x: 0
      }}
      transition={{
        duration: 0.4,
        delay: delay + (index * staggerDelay),
        ease: [0.4, 0, 0.2, 1]
      }}
    >
      {char === ' ' ? '\u00A0' : char}
    </motion.span>
  ));

  return <div className={className} style={{ textWrap: 'balance' } as React.CSSProperties}>{splitText}</div>;
};

export default AnimatedText;